<template>
  <div>
    <img alt="Vue logo" width="1024" src="../assets/product1.jpg">
    <img alt="Vue logo" width="1024" src="../assets/product2.jpg">

    <div style="width:100%;justify-content: center;display: flex;">
      <img alt="Vue logo" style="float:left" width="510" src="../assets/product3-1.jpg">
      <img alt="Vue logo" style="float:right" width="510" src="../assets/product3-2.jpg">
    </div>
  </div>
</template>

<script>
export default {
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
